import { Box, Typography } from '@mui/material'
import { techStack } from '../../utils/siteContent'
import Tag from './Tag'

function TechStack({ tone = 'light' }: { tone?: 'dark' | 'light' }) {
    return (
        <Box sx={{ display: 'grid', gap: { xs: 3, md: 4 }, gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', lg: 'repeat(4, 1fr)' } }}>
            {techStack.map((group) => (
                <Box key={group.name}>
                    <Typography variant="h5" component="h3" sx={{ mb: 1.5 }}>{group.name}</Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        {group.items.map((item) => <Tag key={item} text={item} tone={tone} />)}
                    </Box>
                </Box>
            ))}
        </Box>
    )
}

export default TechStack
